<ion-header translucent="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title class="e2e_title">
      {{ title$ | async }}
    </ion-title>
    <ion-buttons slot="end">
      <ng-content></ng-content>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
